import {
    ChangeDetectionStrategy,
    Component,
    EventEmitter,
    Input,
    Output
} from '@angular/core';

@Component({
    selector: 'lokos-fab-button',
    templateUrl: './fab-button.component.html',
    styleUrl: './fab-button.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class FabButtonComponent {
  @Input() disabled = false;
  @Input({ required: true }) type = 'primary';
  @Input() iconPath = '';
  @Input() tooltip = '';

  @Output() afterClick = new EventEmitter();
}
